export function getTooltipPlacement(
	row: number,
	col: number,
	maxRow: number,
	maxCol: number,
): string {
	const xThreshold = 5;
	const yThreshold = 3;
	const isTop = row < yThreshold;
	const isBottom = row >= maxRow - yThreshold;
	const isLeft = col < xThreshold;
	const isRight = col >= maxCol - xThreshold;
	const isMiddleRow = !isTop && !isBottom;
	const isMiddleCol = !isLeft && !isRight;

	if (isTop && isLeft) {
		return "bottom-start";
	}
	if (isTop && isRight) {
		return "bottom-end";
	}
	if (isTop && isMiddleCol) {
		return "bottom";
	}
	if (isBottom && isLeft) {
		return "top-start";
	}
	if (isBottom && isRight) {
		return "top-end";
	}
	if (isBottom && isMiddleCol) {
		return "top";
	}
	if (isMiddleRow && isLeft) {
		return "right";
	}
	if (isMiddleRow && isRight) {
		return "left";
	}
	return "top";
}

export function radixTooltipFromPlacement(placement: string): {
	side: "top" | "bottom" | "left" | "right";
	align: "start" | "center" | "end";
} {
	const parts = placement.split("-");
	const rawSide = parts[0];
	const side =
		rawSide === "top" ||
		rawSide === "bottom" ||
		rawSide === "left" ||
		rawSide === "right"
			? rawSide
			: "top";
	const rawAlign = parts[1];
	const align =
		rawAlign === "start" || rawAlign === "end" ? rawAlign : "center";
	return { side, align };
}
